const WORDS = ["goencho basics", "Heavyweight cotton", "T-shirts", "Hoodies", "Accessories", "Worn daily", "Built to last"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-ink/90 bg-ink py-6 text-bone md:py-8">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`px-8 font-display text-4xl md:text-6xl ${i % 2 ? "italic font-light" : ""}`}>{w}</span>
            <span className="h-2.5 w-2.5 bg-signal" />
          </span>
        ))}
      </div>
    </section>
  );
};
